import React from 'react'

const Map = () => (
  <div className="map">
    <iframe className="map-inner" title="mBody Health Location" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3009.8381904083412!2d-81.49654508458529!3d41.02879587929868!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88312a15650560e5%3A0x8bd542f1e914957d!2s908%20E%20Waterloo%20Rd%2C%20Akron%2C%20OH%2044306!5e0!3m2!1sen!2sus!4v1630523780403!5m2!1sen!2sus&key=AIzaSyDeChrsDDpU1f8cKWO0hDFvVKB3rWB31LM" allowFullScreen></iframe>
  </div>
)
export default Map;
